import React, { useCallback, useEffect } from 'react';
import { PageLoading } from 'components/atoms/loading';
import { useCreatePortalSessionMutation } from 'queries/billing';
import { loadChargebeeJS } from './chargebee';

interface Props {
  onDismiss?: () => void;
}

export const BillingSelfServePortal = ({ onDismiss }: Props) => {
  const { mutateAsync: createPortalSession } = useCreatePortalSessionMutation();

  const openPortal = useCallback(async () => {
    const instance = await loadChargebeeJS();

    instance.setPortalSession(createPortalSession);
    instance.createChargebeePortal().open(
      {
        close: onDismiss,
      },
      {
        sectionType: window.Chargebee.getPortalSections().PAYMENT_SOURCES,
      },
    );
  }, [createPortalSession, onDismiss]);

  useEffect(() => {
    openPortal();
  }, [openPortal]);

  return (
    <>
      <div className="ant-modal-mask">
        <PageLoading css light />
      </div>
    </>
  );
};
